const HELP_CENTER = {
    LANDING_PAGE: {
        PARENT_ID: 'helpCenter',
        RESOURCE_ID: 'helpCenter',
        SECCION_NAME: 'Help Center',
    },
    RELEASE_NOTES: {
        PARENT_ID: 'helpCenter',
        RESOURCE_ID: 'releaseNotes',
    },
    CONTACT_TECHNICAL_SUPPORT: {
        PARENT_ID: 'helpCenter',
        RESOURCE_ID: 'contactTechnicalSupport',
    },
};

export default HELP_CENTER;
